import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { getData } from "../../services/staticpage-service";

const DynamicFooterPage = () => {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getPageData = async () => {
      setLoading(true);
      try {
        const res = await getData(slug);
        setData(res.data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    getPageData();
  }, [slug]);
  

  return (
    <Box padding="20px" minH="50vh">
      <Flex align="center" justify="center" width="100%" bg="white" flexDir="column">
        <Box width="100%" height="60px" color="black">
          <Text fontSize="24px" fontWeight="600" textAlign="center">
            {data?.category}
          </Text>
        </Box>
        {loading ? (
          "Loading..."
        ) : (
          <Text padding={{base:"15px 20px", md:"30px 50px"}} width={{base: "400px", md:"100%"}}>
            <div dangerouslySetInnerHTML={{ __html: data?.description }} />
          </Text>
        )}
      </Flex>
    </Box>
  );
};

export default DynamicFooterPage;
